import request from '@/api/request'

export default {
  async getImageTypes () {
    return (await request.get(`module/action/ecommerce/moovin/image/get_types`)).data
  }
}



// WEBPACK FOOTER //
// ./src/api/ecommerce/moovin/index.js